import { Inject, Injectable } from "@angular/core";
import { DwDataRequest, DwDatasource, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwOrmDataSource, DwQuery, DwSecurityUserService } from "@devwareapps/devware-cap";
import { AppMetaData, AppMetaDataItemNames } from "../../../meta-data/app-meta-data.service";
import { AdminManagerService } from "../../admin/services/admin-manager.service";

@DwDatasource({
    keyName: 'CourseListDataSource',
    display: 'Course List Data Source',
    itemName: AppMetaDataItemNames.Course,
})
@Injectable()
export class CourstListDataSourceService extends DwOrmDataSource {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) metaDataService: DwMetaDataService,
        private securityUserService: DwSecurityUserService,
        private adminManagerService: AdminManagerService
    ) {
        super(dwOrmDataService, metaDataService, AppMetaDataItemNames.Course);
    }

    initDataSource() {

    }

    prepareRequestQuery(request: DwDataRequest): DwQuery {
        const baseQuery = super.prepareRequestQuery(request);

        const courseListQuery = AppMetaData.Queries.CourseListForStudent.CreateQueryBuilderFromQuery(baseQuery);

        courseListQuery.query.Order=[];
        courseListQuery.addOrderBy(o => o.StudentCourseIsEndorsed);
        courseListQuery.addOrderByDesc(o => o.CourseEndorsementStudentCompletionDateTime);
        courseListQuery.addOrderByDesc(o => o.StudentCoursePercentComplete);
        courseListQuery.addOrderBy(o => o.CourseOrder);

        const aviatorUser = this.adminManagerService.getAviatorUser();

        const userId = aviatorUser.user?.UserId;
        const flightSchoolId = aviatorUser.FlightSchoolId;

        courseListQuery.addFilterAnd(f => f.GroupOr(
            g => g.Equal(a => a.StudentUserId,  userId),
            g => g.IsBlank(a => a.StudentUserId, null)
        ));

        //courseListQuery.addFilterAnd(f => f.Equal(a => a.FlightSchoolCourseFlightSchoolId, flightSchoolId));

        return courseListQuery.query;
    }

}